/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React, { Component } from "react";

import memoize from "memoizee";

import InputLabel from "./Layout/InputLabel";
import InputContainer from "./Layout/InputContainer";
import ErrorMessage from "./Layout/ErrorMessage";
import FilePicker from "./FilePicker";

import FilePreview from "./FilePreview";

import { useResources, useIdPrefix } from "@aetonix/hooks";

class FileListComp extends Component {
	constructor(props) {
		super(props);

		this.state = {
			hasChanged: false,
			list: []
		};

		this.onAdd = handle_add.bind(this);
		this.removeItem = memoize(handle_remove.bind(this));
	}
	render() {
		const props = this.props;
		const localize = props.localize;
		const defaultValue = props.defaultValue || [];
		const schema = props.schema;
		const name = props.name;
		const contrast = props.contrast;
		const video = schema.videoEnabled;
		const pdf = schema.pdfEnabled;
		const downloadEnabled = schema.downloadEnabled;
		const localDisabled = schema.localDisabled;

		const addTitle = localize("form.fileadd");

		const hasChanged = this.state.hasChanged;
		const renderValue = hasChanged ? this.state.list : defaultValue;
		const files = renderValue.map(function (file, index) {
			if (!Object.keys(file).length) {
				return null;
			}
			const onRemove = this.removeItem(index);
			return (
				<FilePreview
					file={file}
					key={file.url || file.file.name}
					onRemove={onRemove}
					contrast={contrast}
					noDownload={!downloadEnabled}
				/>
			);
		}, this);

		return (
			<InputContainer inline={props.inline}>
				<InputLabel schema={schema} />
				<ErrorMessage id={props.id_prefix + props.id + "_error"} errors={props.errors} schema={schema} />
				{files}
				<FilePicker
					id={props.id + "_picker"}
					title={addTitle}
					schema={schema}
					name={name}
					onChange={this.onAdd}
					pdfEnabled={pdf}
					videoEnabled={video}
					localDisabled={localDisabled}
				/>
			</InputContainer>
		);
	}
}

function handle_add(newFile) {
	const hasChanged = this.state.hasChanged;
	const list = (hasChanged ? this.state.list : this.props.defaultValue) || [];
	const newItem = {
		file: newFile
	};

	const newList = list.concat(newItem);

	this.setState({
		hasChanged: true,
		list: newList
	});

	this.props.dispatch("usermetrics:trigger:track", "add file attachment", {
		type: newFile.type
	})();

	const onChange = this.props.onChange;
	if (onChange) onChange(newList);
}

function handle_remove(index) {
	const component = this;
	return function () {
		const defaultValue = component.props.defaultValue;

		const hasChanged = component.state.hasChanged;

		let list;
		if (hasChanged) list = component.state.list.slice();
		else list = (defaultValue || []).slice();
		
		const toBeRemove = list.find(function (item, itemIndex) {
			return itemIndex === index;
		});

		const newList = list.filter(function (item, itemIndex) {
			return itemIndex !== index;
		});

		component.setState({
			hasChanged: true,
			list: newList
		});

		component.props.dispatch("usermetrics:trigger:track", "remove file attachment", {
			fileIndex: index,
			type: toBeRemove?.file?.type
		})();

		const onChange = component.props.onChange;
		if (onChange) onChange(newList);
	};
}

export default function FileList(props) {
	const { localize, dispatch } = useResources();
	const idPrefix = useIdPrefix();
	return <FileListComp {...props} localize={localize} id_prefix={idPrefix} dispatch={dispatch}/>;
}
